import { render, staticRenderFns } from "./motivos-evento-data-list.vue?vue&type=template&id=27a04b95"
import script from "./motivos-evento-data-list.vue?vue&type=script&lang=js"
export * from "./motivos-evento-data-list.vue?vue&type=script&lang=js"
import style0 from "./motivos-evento-data-list.vue?vue&type=style&index=0&id=27a04b95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports